import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="fancy-select"
export default class extends Controller {
  static targets = ["list", "item", "selected", "input", "search"];

  connect() {
    document.addEventListener("click", this.handleClickOutside.bind(this));
    this.setDefaultIfPossible();
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside.bind(this));
  }

  toggle() {
    if (this.listTarget.classList.contains("hidden")) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.listTarget.classList.remove("hidden");
    if (this.hasSearchTarget) {
      this.searchTarget.focus();
    }
  }

  close() {
    this.listTarget.classList.add("hidden");
    if (this.hasSearchTarget) {
      this.searchTarget.value = "";
      this.filter();
    }
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  setDefaultIfPossible() {
    const id = this.element.dataset.defaultValue;
    if (id) {
      const selectItem = this.itemTargets.find((item) => item.dataset.id == id);
      console.log({
        selectItem,
        itemTargets: this.itemTargets,
        id,
        element: this.element,
      });
      if (selectItem) {
        this.selectedTarget.innerHTML =
          selectItem.querySelector(`[data-js="title"]`)?.outerHTML;
        selectItem
          .querySelector(`[data-js="check"]`)
          .classList.remove("hidden");
        // Set the hidden inputs value to the ID
        this.inputTarget.value = id;
      }
    }
  }

  choose(e) {
    const selectItem = e.currentTarget;
    const id = selectItem.dataset.id;

    // Copy the label HTML and place it into the outer form element]
    this.selectedTarget.innerHTML =
      selectItem.querySelector(`[data-js="title"]`).outerHTML;
    // Set the hidden inputs value to the ID
    this.inputTarget.value = id;
    // Remove checkmarks from all other elements
    this.itemTargets.forEach((itemTarget) => {
      itemTarget.querySelector(`[data-js="check"]`).classList.add("hidden");
    });
    // Add checkmark to selected item.
    selectItem.querySelector(`[data-js="title"]`);
    selectItem.querySelector(`[data-js="check"]`).classList.remove("hidden");

    this.close();

    // Trigger a change event on the input to propagate to any attached data actions
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }));

    if (this.element.dataset.autoSubmit === "true") {
      // Find the closest form submit button and click it
      const submitButtons = this.element
        .closest("form")
        .querySelectorAll("button[type=submit]");
      if (submitButtons.length > 0) {
        submitButtons[submitButtons.length - 1].click();
      }
    }
  }

  filter() {
    const searchTerm = this.hasSearchTarget
      ? this.searchTarget.value.toLowerCase()
      : "";

    this.itemTargets.forEach((item) => {
      const searchText = item.dataset.searchText || "";
      const isVisible = searchText.includes(searchTerm);
      item.classList.toggle("hidden", !isVisible);
    });
  }
}
